export const pools = [
  {
    pid: 0,
    stakedTokenName: "GFC",
    stakedTokenSymbol: "GFC",
    rewardTokenName:"GFC",
    stakedTokenDecimals: 18,
    tokenAddress: "0x071AC29d569a47EbfFB9e57517F855Cb577DCc4C",
    poolAddress: "0x162ba8F3a02C321Cf0aa360d2C5B5dd523D7F35E",
    getUrl:"https://app.sushi.com/swap?inputCurrency=0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619&outputCurrency=0x071AC29d569a47EbfFB9e57517F855Cb577DCc4C",
    weight: 0.25,
    toFixed: 2
  },
  {
    pid: 1,
    stakedTokenName: "GFC:WETH LP",
    stakedTokenSymbol: "GFC SLP",
    rewardTokenName:"GFC",
    stakedTokenDecimals: 18,
    tokenAddress: "0xD8E7d368ab9BDF0010A9934B0e801B3F38CECEF6",
    poolAddress: "0x29De9Dfa4ADFE50C878fb2FffF8C1b28d9e24355",
    getUrl:"https://app.sushi.com/add/0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619/0x071AC29d569a47EbfFB9e57517F855Cb577DCc4C",
    weight: 0.75,
    toFixed: 2
  }
];
